import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { ReviewActions } from "@/features/reviews/components/review-actions"
import { SnapshotPageSections } from "@/features/reviews/components/snapshot-page"
import { reviewQueries } from "@/queries/reviews"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/reviews/$reviewId/firm/"
)({
  component: ReviewFirmPage,
})

function ReviewFirmPage() {
  const { reviewId } = Route.useParams()
  const { data: review } = useSuspenseQuery(reviewQueries.detail(reviewId))
  const page = review.pages.find((entry) => entry.kind === "firm")

  return (
    <>
      <PageHeader title="Firm" actions={<ReviewActions review={review} />} />
      <PageContent>
        {page ? <SnapshotPageSections page={page} /> : null}
      </PageContent>
    </>
  )
}
